(() => {
  if (window.rocksolarDeferredZoomInstalled) return;
  const loader = document.currentScript;
  const scriptUrl = loader?.dataset.photoswipeScript;
  const stylesUrl = loader?.dataset.photoswipeStyles;
  if (!scriptUrl || !stylesUrl) return;
  window.rocksolarDeferredZoomInstalled = true;
  let libraryPromise;
  const loadLibrary = () => {
    if (window.FoxTheme?.PhotoSwipe && window.FoxTheme?.PhotoSwipeLightbox) return Promise.resolve();
    if (libraryPromise) return libraryPromise;
    if (!document.querySelector(`link[href="${stylesUrl}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = stylesUrl;
      document.head.appendChild(link);
    }
    libraryPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = scriptUrl;
      script.onload = resolve;
      script.onerror = () => { libraryPromise = null; script.remove(); reject(new Error('Image zoom failed to load')); };
      document.head.appendChild(script);
    });
    return libraryPromise;
  };
  const initialize = (gallery) => {
    if (gallery.dataset.zoomInitialized === 'true') return Promise.resolve();
    if (gallery.zoomInitialization) return gallery.zoomInitialization;
    gallery.zoomInitialization = Promise.all([customElements.whenDefined('media-gallery'), loadLibrary()]).then(() => {
      if (!gallery.isConnected) return;
      gallery.init();
      gallery.dataset.enableImageZoom = 'true';
      gallery.enableImageZoom = true;
      gallery.initImageZoom();
      gallery.dataset.zoomInitialized = 'true';
    }).finally(() => { gallery.zoomInitialization = null; });
    return gallery.zoomInitialization;
  };
  const target = (event) => {
    const control = event.target.closest('.js-photoswipe--zoom');
    const gallery = control?.closest('media-gallery[data-defer-image-zoom="true"]');
    return { control, gallery };
  };
  ['pointerover', 'focusin'].forEach((name) => document.addEventListener(name, (event) => {
    const { gallery } = target(event);
    if (gallery) initialize(gallery).catch(() => {});
  }));
  document.addEventListener('click', (event) => {
    const { control, gallery } = target(event);
    if (!gallery || gallery.dataset.zoomInitialized === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    initialize(gallery).then(() => { if (control.isConnected) control.click(); }).catch(() => {});
  }, true);
})();
